import { lazy } from "react";

// Б цагийн тохиргоо
const Bsettings = lazy(() => import("@views/Institute/Settings"))

const InstituteRoutes = [
	{
		path: "bsettings",
		element: <Bsettings />,
	},
];

export default InstituteRoutes;
